class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');

		if (this.input) {
            // Keep exact-category syntax in the request, not in the visible input.
            if (this.input.value === '"VFX"') this.input.value = 'VFX';
            this.input.form.addEventListener("formdata", this.onFormData.bind(this));
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
            this.input.addEventListener("compositionend", this.onChange.bind(this));
			this.input.addEventListener(
				"input",
				debounce((event) => {
					if (!event.isComposing) this.onChange(event);
				}, 300).bind(this),
			);
		}
	}

    getSearchQuery(term) {
        // Shopify broadens the short category VFX into unrelated GUI/character
        // results. An exact phrase keeps both suggestions and submitted search relevant.
        const query = term.trim();
        return /^vfx$/i.test(query) ? '"VFX"' : query;
    }

    onFormData(event) {
        if (event.target !== this.input.form) return;
        // Product-card quick-add forms can contribute hidden cart fields to the
        // enclosing search form. Submit search parameters only.
        for (const key of [...event.formData.keys()]) {
            if (key !== 'q' && key !== 'type' && !key.startsWith('options[')) {
                event.formData.delete(key);
            }
        }
        event.formData.set('q', this.getSearchQuery(this.input.value));
    }

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a');
	}

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		event.preventDefault();
		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			this.input.value = "";
			//this.input.focus();
		}
	}
}

customElements.define("search-form", SearchForm);
